import { testImageConstants } from "../_redux-constants";

export function testImageReducer(
  state = {
    testImageLoading: false,
    testImageData: [],
    testImageError: null,
  },
  action
) {
  switch (action.type) {
    case testImageConstants.TEST_IMAGE_LOADING:
      return Object.assign({}, state, {
        testImageLoading: true,
        testImageError: null,
      });
    case testImageConstants.TEST_IMAGE_SUCCESS:
      return Object.assign({}, state, {
        testImageLoading: false,
        testImageData: [action.data],
      });
    case testImageConstants.TEST_IMAGE_FAILURE:
      return Object.assign({}, state, {
        testImageLoading: false,
        testImageError: action.error,
      });
    default:
      return state;
  }
}
